var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRiskMembershipJitCs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qbuya41dza",
    d: "M0 0h15.895v18.985H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEB3B7",
    d: "M3.388 11.61h1.15v-1.15h-1.15zM5.405 13.703l.813.813-.813.813-.813-.813zM8.312 6.438H9.46v-1.15h-1.15zM9.001 9.655c-.149 0-.292.027-.425.075L5.393 6.729l-.789.837 3.184 3a1.264 1.264 0 1 0 1.213-.911z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ouaa8qcfeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qbuya41dza"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.977 18.23c0-.316.052-.625.15-.919-2.63-.934-4.518-3.446-4.518-6.392a6.789 6.789 0 0 1 6.782-6.781c1.668 0 3.196.606 4.38 1.609h2.58l.544-.544-1.788-1.788-.745.745a8.345 8.345 0 0 0-4.166-1.592v-.959h1.609V0H5.977v1.61h1.61v.958A8.39 8.39 0 0 0 6.08 18.985a2.915 2.915 0 0 1-.103-.756z",
    fill: "#AEB3B7",
    mask: "url(#ouaa8qcfeb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB3B7",
    d: "m15.976 9.655.88-2.758h-5.364l.88 2.758zM14.271 15.134c.589.144 1.574.383 1.574 1.504 0 .28-.093 1.092-1.096 1.336v.647h-1.15v-.64c-.657-.174-1.096-.685-1.096-1.343h1.15c0 .24.349.259.456.259.586 0 .586-.175.586-.259 0-.155-.026-.224-.696-.387-.56-.136-1.496-.364-1.496-1.396 0-.576.376-1.156 1.096-1.344v-.637h1.15v.655c.751.203 1.096.766 1.096 1.326h-1.15c0-.238-.448-.257-.586-.257-.29 0-.456.094-.456.257 0 .09.058.143.618.28zm6.027 2.095-4.162-6.424h-3.924L8.05 17.229a1.75 1.75 0 0 0-.313 1c0 .978.8 1.771 1.788 1.771h9.298a1.78 1.78 0 0 0 1.788-1.77c0-.372-.116-.716-.313-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskMembershipJitCs);
export default __webpack_public_path__ + "static/media/high-risk-membership-jit-cs.20883bdaddfdd643f2caac123c8ba3df.svg";
export { ForwardRef as ReactComponent };